const equalizeBannerHeight = () => {
  const bannerHeight = $('.banner').outerHeight(true);
  const isMobile = $(window).width() <= 992;

  $('.banner-open #shopify-section-menu-bar').css('top', `${bannerHeight}px`);
  $('.banner-open > main').css('maring-top', `${bannerHeight}px`);
}

const mobileMenuPosition = () => {
  const mobileMenu              = document.querySelector('#nav-drawer__mobile');

  if (mobileMenu != null) {
    const menuBarHeight           = document.querySelector('#shopify-section-menu-bar').offsetHeight;
    const announcementBarHeight   = document.querySelector('#shopify-section-announcement-bar .banner').offsetHeight;
    const MenuOffset              = (menuBarHeight+announcementBarHeight)+'px';

    mobileMenu.style.top = MenuOffset;
    mobileMenu.style.height = 'calc(100% - '+MenuOffset+')'
  };
}


const initBannerSlider = () => {
  const $slider = $('.js-announcement-bar-slider');
  const config = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    swipe: false,
    autoplay: true,
    autoplaySpeed: (parseInt($slider.data('interval') * 1000)),
    adaptiveHeight: true
  };

  $slider
    .on('init', function(event) {
      equalizeBannerHeight();
      mobileMenuPosition();
    })
    .on('afterChange', function(event, slick, currentSlide, nextSlide) {
      equalizeBannerHeight();
      mobileMenuPosition();
    })
    .not('.slick-initialized')
    .slick(config);
}

$(window).on('shopify:section:load load', function(event) {
  initBannerSlider();
});

const $countdownElement = $('.js-countdown-timer');
const countdownTimestamp = new Date($countdownElement.attr('datetime')).getTime();

const countdownInterval = setInterval(() => {
  const now = new Date().getTime();
  const diff = countdownTimestamp - now;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  $countdownElement.text(`
    ${days > 0 ? `${days}d` : ''}
    ${hours > 0 ? `${hours}h` : ''}
    ${minutes > 0 ? `${minutes}m` : ''}
    ${seconds > 0 ? `${seconds}s` : ''}
  `);

  if (diff < 0) {
    clearInterval(countdownInterval);
    $countdownElement.parent().html($countdownElement.data('expire-text'));
  }
}, 1000);
